import { useWatch } from 'react-hook-form';

import {
  APRType,
  FinanceFormValues,
  useFinanceFormContext,
} from '../../context';

export interface TermsHook {
  apr: string | undefined;
  aprType: APRType | undefined;
  duration: number | undefined;
  termRef: React.MutableRefObject<HTMLDivElement | null>;
}

export default function useTerms(): TermsHook {
  const { termRef } = useFinanceFormContext();

  const [apr, aprType, duration] = useWatch<
    FinanceFormValues,
    ['apr', 'aprType', 'duration']
  >({
    name: ['apr', 'aprType', 'duration'],
  });

  return {
    apr,
    aprType,
    duration,
    termRef,
  };
}
